import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { http } from '../http';

interface UseReactQueryParameters {
  endpoint: string;
  enabled?: boolean;
  queryKey: string[];
  staleTime?: number;
  cacheTime?: number;
  onSuccessCallback?: any;
  axiosOptions: AxiosRequestConfig;
}

export const useReactQuery = ({
  endpoint,
  queryKey,
  staleTime,
  cacheTime,
  axiosOptions,
  onSuccessCallback,
  enabled = true,
}: UseReactQueryParameters) =>
  useQuery({
    retry: 1,
    queryKey: queryKey,
    cacheTime: cacheTime,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (endpoint) {
        const response = await http.get(endpoint, axiosOptions);
        return response.data;
      } else {
        return null;
      }
    },
    enabled: enabled,
    staleTime: staleTime,
    onError: (err: AxiosError) => err,
    onSuccess: data => {
      onSuccessCallback?.(data);
    },
  });
